import { useState } from "react"
import Image from "next/image"
import { useLang } from "hooks/useLang"
import AuthModal from "components/bookingv2/AuthModal/AuthModal"

const AuthSection = ({ isLoading }: { isLoading: boolean }) => {
    const { t } = useLang()
    const [isAuthModalOpen, setIsAuthModalOpen] = useState(false)

    if (isLoading) return <></>

    return (
        <div className="md:max-w-[1220px] w-[80%] layout  flex flex-col height-auto  my-12">
            <div className="bg-gradient-to-r from-[#1e15487b] to-[#fc267c75] w-full h-full rounded-[15px] flex flex-col items-center justify-between p-10 gap-8">
                {/* Header */}
                <div className="flex flex-col w-full justify-center items-center gap-4">
                    <Image
                        src="/svg/accountIcon.svg"
                        alt="account"
                        width={65}
                        height={65}
                        className="w-[65px] h-[65px]"
                    />
                    <h2 className="text-2xl font-bold text-white text-center">
                        {t("auth_section_title")}
                    </h2>
                    <h2 className="text-lg   text-white text-center">
                        {t("auth_section_subtitle")}
                    </h2>
                </div>

                <div className="flex flex-col w-full justify-center items-center">
                    <button
                        onClick={() => setIsAuthModalOpen(true)}
                        className="bg-[#F2EF1D] hover:bg-[#f2ee1da7] flex items-center justify-center px-20 py-2 rounded-full cursor-pointer transition-all duration-200"
                    >
                        <span className="font-bold text-black">
                            {t("signinOrLogin")}
                        </span>
                    </button>
                </div>
            </div>

            {/* Auth Modal */}
            {isAuthModalOpen && (
                <AuthModal onClose={() => setIsAuthModalOpen(false)} />
            )}
        </div>
    )
}

export default AuthSection
